import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  loading: false,
};

// User by Id actions
const userReq = createAction("userByIdRequest");
const userSuccess = createAction("userByIdSuccess");
const userFail = createAction("userByIdFailure");

// Practitioner actions
const practionerSuccess = createAction("practionerSuccess");
const practionerFail = createAction("practionerFailure");

// Wheel of Life actions
const wheelOfLifeSuccess = createAction("wheelOfLifeSuccess");
const wheelOfLifeFail = createAction("wheelOfLifeFailure");

// Clear user data
const clear = createAction("clearUserData");

// IPHC Practitioner actions
const iphcPractitionerReq = createAction("iphcPractitionerRequest");
const iphcPractitionerSuccess = createAction("iphcPractitionerSuccess");
const iphcPractitionerFail = createAction("iphcPractitionerFailure");

// Patient actions
export const patientRequest = createAction("patientRequest");
export const patientSuccess = createAction("patientSuccess");
export const patientFailure = createAction("patientFailure");

export const userReducer = createReducer(initialState, (builder) => {
  builder
    // User by Id
    .addCase(userReq, (state) => {
      state.loading = true;
    })
    .addCase(userSuccess, (state, action) => {
      state.loading = false;
      state.userData = action.payload.user;
    })
    .addCase(userFail, (state) => {
      state.loading = false;
    })

    // Practitioner
    .addCase(practionerSuccess, (state, action) => {
      state.loading = false;
      state.practitioner = action.payload.practitioner;
    })
    .addCase(practionerFail, (state) => {
      state.loading = false;
    })

    // Wheel of Life
    .addCase(wheelOfLifeSuccess, (state, action) => {
      state.loading = false;
      state.wheelOfLifeData = action.payload.wheelOfLife;
    })
    .addCase(wheelOfLifeFail, (state) => {
      state.loading = false;
    })

    // Clear User Data
    .addCase(clear, (state) => {
      state.userData = null;
      state.practitioner = null;
      state.wheelOfLifeData = null;
      state.loading = false;
      state.iphcPractitioner = [];
      state.patient = null;
      state.error = null;
    })

    // IPHC Practitioner
    .addCase(iphcPractitionerReq, (state) => {
      state.loading = true;
    })
    .addCase(iphcPractitionerSuccess, (state, action) => {
      state.loading = false;
      state.iphcPractitioner = action.payload.iphcPractitioner;
    })
    .addCase(iphcPractitionerFail, (state) => {
      state.loading = false;
      state.iphcPractitioner = [];
    })

    // Patient
    .addCase(patientRequest, (state) => {
      state.loading = true;
    })
    .addCase(patientSuccess, (state, action) => {
      state.loading = false;
      state.patient = action.payload; // store patient data
      state.error = null;
    })
    .addCase(patientFailure, (state, action) => {
      state.loading = false;
      state.patient = null;
      state.error = action.payload; // store error message
    });
});
